import React from 'react';
import { SearchIcon, ClearIcon } from './icons/ViewTicketsIcons';

const SearchBar = ({
  searchQuery,
  onSearchChange,
  onClearSearch
}) => {
  return (
    <div className="p-4 border-b border-gray-200 bg-white">
      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <SearchIcon className="h-5 w-5 text-blue-600" />
        </div>
        <input
          type="text"
          placeholder="Search tickets by ID, tracking ID, category, requester, priority, status, or description..."
          value={searchQuery}
          onChange={onSearchChange}
          className="w-full pl-10 pr-10 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 font-poppins bg-white/80 backdrop-blur-sm transition-all duration-300 shadow-sm hover:shadow-md"
        />
        {searchQuery && (
          <button
            onClick={onClearSearch}
            className="absolute inset-y-0 right-0 pr-3 flex items-center"
          >
            <ClearIcon className="h-5 w-5 text-gray-400 hover:text-gray-600" />
          </button>
        )}
      </div>
    </div>
  );
};

export default SearchBar;
